<div #modal class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button id='memberAbTestVariantsModalDialogClose' type="button" class="close" data-dismiss="modal"
          aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h2 class="modal-title">AB Test Variants for Member</h2>
      </div>
      <div class="modal-body">
        <div *ngFor="let abTestVariant of abTestVariants" class="ab-test">
          <div class="data-field">
            <label for="ab-test-variant-name"><strong>Name:</strong></label>
            <span id="ab-test-variant-name"><code>{{ abTestVariant?.name }}</code></span>
          </div>
          <div class="data-field">
            <label for="ab-test-variant-variant"><strong>Variant:</strong></label>
            <span id="ab-test-variant-variant">{{ abTestVariant?.variant }}</span>
          </div>
        </div>
      </div>
      <div class='modal-actions'>
        <button id='abTestVaraintsDialogOK' type="button" data-dismiss="modal" class="btn btn-info">OK</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/member/ab-tests-modal-dialog/ab-tests-modal-dialog.component.html